// eslint-disable-next-line
var ajax = $.ajax;
// eslint-disable-next-line
const url_req = "/php/request.php";

export function updateAuth() {
  // eslint-disable-next-line
  let auth = BX24.getAuth();
  return {
    domain: auth.domain,
    token: auth.access_token,
  };
}

export function generateFormData(data = {}) {
  // let formData = new FormData();
  // for (let [key, value] of Object.entries(data)) {
  //   if (value) formData.append(key, value);
  // }
  // return formData;
  let formData = new FormData();
  for (let [key, value] of Object.entries(data)) {
    if (value) {
      if (
        key == "token" ||
        key == "domain" ||
        key == "run" ||
        key == "user_id" ||
        key == "field"

      ) { formData.append(key, value); }
    }
  }
  FormDataRecursion(formData, data);
  return formData;
}

export function generateFormDataWithImage(data = {}, img = []) {
  let formData = new FormData();
  for (let [key, value] of Object.entries(data)) {
    if (value) {
      if (
        key == "token" ||
        key == "domain" ||
        key == "run" ||
        key == "user_id"
      ) { formData.append(key, value); }
    }
  }
  FormDataRecursion(formData, data);

  if (img.length > 0)
    img.forEach((file) => {
      console.log(file);
      if (Object.keys(file).length != 5) {
        formData.append("files[]", file);
      }
    });
  return formData;
}

function FormDataRecursion(formData, dataVal, dataKey, dataSubKey) {
  if (typeof dataVal != "object") {
    if (dataSubKey != undefined) {
      return formData.append(dataSubKey + "[" + dataKey + "]", dataVal);
    }
    return formData.append(dataKey, dataVal);
  } else {
    for (let [key, value] of Object.entries(dataVal)) {
      FormDataRecursion(formData, value, key, dataKey);
    }
  }
}

export function sendEditBxData(params) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "editBxData",
      domain: auth.domain,
      token: auth.token,
      ...params
    },
  });
}

export function sendEditData(params) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "editData",
      domain: auth.domain,
      token: auth.token,
      ...params
    },
  });
}

export function saveLicense(key) {
  let auth = updateAuth();
  return ajax({
    type: "POST",
    url: url_req,
    data: {
      run: "savelicense",
      licensekey: key,
      domain: auth.domain,
      auth: auth.token,
    },
  });
}